import React from 'react';
import { Field } from 'formik';
import { FovFieldError, FovInput, FovSelect, FovOption, VerticalSpacer } from 'components';
import { HeightContainer, Label } from './RPCFormStyles';

const HeightFields = ({ form, isImageProvided, units }) => {
  if (!isImageProvided) {
    return null;
  }

  const placeholder = data => (
    units.find(unit => unit.factor === +data.field.value)?.label
  );

  return (
    <HeightContainer>
      <Label name={`Label_Height${Math.random()}`}>
        Height*
        <VerticalSpacer size={10} />

        <Field type='number' name='height'>
          {data => (
            <FovInput
              name={data.field.name}
              value={data.field.value}
              {...data.field}
            />
          )}
        </Field>

        <FovFieldError name='height' />
      </Label>

      <Label name={`Label_Unit${Math.random()}`}>
        Unit
        <VerticalSpacer size={10} />

        <Field type='select' name='heightFactor'>
          {data => (
            <FovSelect
              value={data.field.value}
              placeholder={placeholder(data)}
              onChange={(e, newVal) => {
                form.setFieldValue(data.field.name, newVal);
              }}
            >
              {units.map((unit, index) => (
                <FovOption key={index} value={unit.factor}>
                  {unit.label}
                </FovOption>
              ))}
            </FovSelect>
          )}
        </Field>

        <FovFieldError name='heightFactor' />
      </Label>
    </HeightContainer>
  );
};

export default HeightFields;

